import React from "react";

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Skeleton from "@material-ui/lab/Skeleton";

import { makeStyles } from "@material-ui/core/styles";
import { getTokens } from "../../styles/tokens";
import { StatusBadge } from "../ui";
import EmptyState from "../EmptyState";
import PeopleOutlineIcon from "@material-ui/icons/PeopleOutline";

import moment from 'moment';

import Rating from '@material-ui/lab/Rating';
import { i18n } from "../../translate/i18n";

const useStyles = makeStyles(theme => {
    const t = getTokens(theme.palette.type, theme.palette.primary.main);
    return {
        container: {
            overflowX: "auto",
        },
        table: {
            minWidth: 720,
            "& tbody tr:last-child td": { borderBottom: 0 },
        },
        name: {
            fontWeight: 600,
            color: t.text,
        },
        skeleton: {
            borderRadius: t.radius.md,
            margin: 20,
        },
    };
});

export function RatingBox({ rating }) {
    const ratingTrunc = rating === null ? 0 : Math.trunc(rating);
    return <Rating
        defaultValue={ratingTrunc}
        max={3}
        readOnly
    />
}

export default function TableAttendantsStatus(props) {
    const { loading, attendants } = props
    const classes = useStyles();

    function renderList() {
        return attendants.map((a, k) => (
            <TableRow key={k}>
                <TableCell className={classes.name}>{a.name}</TableCell>
                <TableCell align="right">{a.rating}</TableCell>
                <TableCell align="right">{a.countRating}</TableCell>
                <TableCell align="right">{a.tickets}</TableCell>
                <TableCell align="right">{formatTime(a.avgWaitTime, 2)}</TableCell>
                <TableCell align="right">{formatTime(a.avgSupportTime, 2)}</TableCell>
                <TableCell>
                    <StatusBadge
                        status={a.online ? "online" : "offline"}
                        label={a.online ? "Online" : "Offline"}
                        size="sm"
                    />
                </TableCell>
            </TableRow>
        ))
    }

    function formatTime(minutes) {
        return moment().startOf('day').add(minutes, 'minutes').format('HH[h] mm[m]');
    }

    return (!loading ?
        <TableContainer className={classes.container}>
            <Table id="grid-attendants" className={classes.table}>
                <TableHead>
                    <TableRow>
                        <TableCell>{i18n.t("dashboard.users.name")}</TableCell>
                        <TableCell align="right">{i18n.t("dashboard.assessments.score")}</TableCell>
                        <TableCell align="right">{i18n.t("dashboard.assessments.ratedCalls")}</TableCell>
                        <TableCell align="right">{i18n.t("dashboard.assessments.totalCalls")}</TableCell>
                        <TableCell align="right">{i18n.t("dashboard.cards.averageWaitingTime")}</TableCell>
                        <TableCell align="right">{i18n.t("dashboard.cards.averageServiceTime")}</TableCell>
                        <TableCell>{i18n.t("dashboard.cards.status")}</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {attendants.length > 0 ? renderList() : (
                        <TableRow>
                            <TableCell colSpan={7}>
                                <EmptyState
                                    icon={<PeopleOutlineIcon />}
                                    title="Nenhum atendente no período"
                                    message="Ajuste os filtros para ver o desempenho da equipe."
                                />
                            </TableCell>
                        </TableRow>
                    )}
                </TableBody>
            </Table>
        </TableContainer>
        : <Skeleton variant="rect" height={150} className={classes.skeleton} />
    )
}
